import _defaultsDeep from 'lodash/defaultsDeep';
import _get from 'lodash/get';

export default class RailsApi {
  static get csrfToken(): string | null {
    return _get(document.querySelector('meta[name="csrf-token"]'), 'content', null);
  }

  static buildFetchOpts(opts: RequestInit = {}) {
    return _defaultsDeep(opts, {
      headers: {
        'X-CSRF-Token': this.csrfToken,
        'X-REQUESTED-WITH': 'XMLHttpRequest',
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin',
    }) as RequestInit;
  }

  static fetch(url: string, opts: RequestInit = {}) {
    return fetch(url, this.buildFetchOpts(opts));
  }

  static post(url: string, opts: RequestInit = {}) {
    return fetch(url, this.buildFetchOpts(Object.assign(opts, { method: 'post' })));
  }
}
